import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ProductListModule } from '../../shop/productos/product-list/product-list.module';
import { PopupBeforePayComponent } from './popup-before-pay.component';


@NgModule({
  declarations: [
    PopupBeforePayComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ProductListModule
  ]
})
export class PopupBeforePayModule {
}
